import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import AddressSvg from "./dynamicSvg/AddressSvg";
import OrdersSvg from "./dynamicSvg/OrdersSvg";
import PpSvg from "./dynamicSvg/PpSvg";
import ProfileSvg from "./dynamicSvg/ProfileSvg";
import TcSvg from "./dynamicSvg/TcSvg";
import WishlistSvg from "./dynamicSvg/WishlistSvg";

function AccountNav() {
    let location = useLocation();

  return (
    <div className="account-nav-parent even-spacer-y">
      <div className="account-nav-sub">
        <span className="account-nav-subheading">My Account</span>
        <div className="account-nav-category-list">
          <Link  to="/user">
            <Row>
              <Col md={2} className="account-nav-counter-column">
                <span className=" text-center">
                  <ProfileSvg isActive={location.pathname === "/user" ? true : false} />
                </span>
              </Col>
              <Col
                md={10}
                className={`d-flex align-items-center subnav-text ${location.pathname === "/user" ? "active" : ""} `}
              >
                <span className="">Profile</span>
              </Col>
            </Row>
          </Link>
          <Link to="/user/address/">
          <Row>
            <Col md={2} className="account-nav-counter-column">
              <span className=" text-center">
                <AddressSvg isActive={false} />
              </span>
            </Col>
            <Col md={10} className="d-flex align-items-center subnav-text">
              <span className="">Add Address</span>
            </Col>
          </Row>
          </Link>
          
        </div>
      </div>

      <div className="account-nav-sub">
        <span className="account-nav-subheading">Orders</span>
        <div className="account-nav-category-list">
            <Link to="/user/orders/">
            <Row>
            <Col md={2} className="account-nav-counter-column">
              <span className=" text-center">
                <OrdersSvg isActive={location.pathname === "/user/orders/" ? true : false} />
              </span>
            </Col>
            <Col md={10}className={`d-flex align-items-center subnav-text ${location.pathname === "/user/orders/" ? "active" : ""} `}>
              <span className="">Orders</span>
            </Col>
          </Row>
            </Link>
          
        </div>
      </div>
      <div className="account-nav-sub">
        <span className="account-nav-subheading">Quick Links</span>
        <div className="account-nav-category-list">
            <Link to="/wishlist">
            <Row>
            <Col md={2} className="account-nav-counter-column">
              <span className=" text-center">
                <WishlistSvg />
              </span>
            </Col>
            <Col md={10} className="d-flex align-items-center subnav-text">
              <span className="">Wishlist</span>
            </Col>
          </Row>
            </Link>
          
        </div>
      </div>
      <div className="account-nav-sub">
        <span className="account-nav-subheading">Legal</span>
        <div className="account-nav-category-list">
          
          <Link to="/privacypolicy">
          <Row>
            <Col md={2} className="account-nav-counter-column">
              <span className=" text-center">
                <PpSvg isActive={false} />
              </span>
            </Col>
            <Col md={10} className="d-flex align-items-center subnav-text">
              <span className="">Privacy Policy</span>
            </Col>
          </Row>
          </Link>
          <Link to="/termsconditions">
          <Row>
            <Col md={2} className="account-nav-counter-column">
              <span className=" text-center">
                <TcSvg isActive={false} />
              </span>
            </Col>
            <Col md={10} className="d-flex align-items-center subnav-text">
              <span className="">Terms & Conditions</span>
            </Col>
          </Row>
          </Link>
          
        </div>
      </div>
    </div>
  );
}

export default AccountNav;
